function showCurrentLink() {
    const mainMenuList = document.querySelectorAll(
        ".navigation.main-menu__list"
    );

    function isCurrentLink(link) {
        if (link.href.endsWith("/#")) return false;

        try {
            const linkUrl = new URL(link.href, window.location.origin);
            const currentUrl = new URL(window.location.href);

            const normalize = (p) => {
                if (!p) return "/";
                try {
                    let np = decodeURI(p);
                    if (!np.startsWith("/")) np = "/" + np;
                    if (np.length > 1 && np.endsWith("/")) np = np.slice(0, -1);
                    if (np.endsWith("/index.php")) np = np.slice(0, -10) || "/";
                    return np;
                } catch {
                    return "/";
                }
            };

            const linkPath = normalize(linkUrl.pathname);
            const currentPath = normalize(currentUrl.pathname);

            if (currentPath === linkPath) return true;

            if (linkPath !== "/" && currentPath.startsWith(linkPath)) {
                const remainder = currentPath.slice(linkPath.length);
                if (remainder === "" || remainder.startsWith("/")) return true;
            }

            return false;
        } catch {
            return false;
        }
    }

    if (mainMenuList) {
        mainMenuList.forEach((mainMenuList) => {
            const navLinks = mainMenuList.children;
            Array.from(navLinks)?.forEach((navLink) => {
                navLink.classList.remove("current");
                const link = navLink.firstElementChild;

                if (isCurrentLink(link)) {
                    navLink.classList.add("current");
                }
            });
        });
    }
}
showCurrentLink();

function improveNavA11y() {
    const dropdownNavLinks = document.querySelectorAll(
        ".navigation.main-menu__list li.dropdown"
    );

    if (dropdownNavLinks) {
        dropdownNavLinks.forEach((dropdownNavLink) => {
            // MOUSE
            dropdownNavLink.addEventListener("mouseover", () => {
                dropdownNavLink.setAttribute("aria-expanded", "true");
            });
            dropdownNavLink.addEventListener("mouseout", () => {
                dropdownNavLink.setAttribute("aria-expanded", "false");
            });

            // KEYBOARD
            const toggle = dropdownNavLink.querySelector("a");

            if (toggle) {
                toggle.addEventListener("focus", () => {
                    dropdownNavLink.setAttribute("aria-expanded", "true");
                });

                dropdownNavLink.addEventListener("focusout", () => {
                    setTimeout(() => {
                        if (!dropdownNavLink.contains(document.activeElement)) {
                            dropdownNavLink.setAttribute(
                                "aria-expanded",
                                "false"
                            );
                        }
                    }, 0);
                });
            }
        });
    }
}
improveNavA11y();

function openMobileNavOnClick() {
    const dropdownLinks = document.querySelectorAll(
        ".mobile-nav__container li.dropdown"
    );
    dropdownLinks.forEach((dropdownLink) => {
        const a = dropdownLink.querySelector("a");
        const button = dropdownLink.querySelector("button");
        a.addEventListener("click", (e) => {
            e.preventDefault();
            button?.click();
        });
        button.addEventListener("click", (e) => {
            e.stopPropagation();
        });
    });
}
openMobileNavOnClick();

function addLightbox() {
    const galleries = ["#single-referencie-gallery"];
    galleries.forEach((gallery) => {
        new PhotoSwipeLightbox({
            gallery,
            children: "a",
            pswpModule: PhotoSwipe,
        }).init();
    });
}
addLightbox();

function fixCustomCursorClick() {
    const cursor = document.querySelector(".custom-cursor__cursor");
    const cursorinner = document.querySelector(".custom-cursor__cursor-two");
    if (!cursor || !cursorinner) return;

    document.addEventListener("pointerdown", () => {
        cursor.classList.add("click");
        cursorinner.classList.add("custom-cursor__innerhover");
    });
    document.addEventListener("pointerup", () => {
        cursor.classList.remove("click");
        cursorinner.classList.remove("custom-cursor__innerhover");
    });
}
fixCustomCursorClick();

function focusSearchOnOpen() {
    const popup = document.querySelector(".search-popup");
    const input = document.querySelector(
        '.search-popup input#search, .search-popup input[type="search"], .search-popup input[type="text"]'
    );
    if (!popup || !input) return;

    const tryFocus = () => {
        if (popup.classList.contains("active")) {
            setTimeout(() => {
                try {
                    input.focus();
                } catch {}
            }, 50);
        }
    };

    document.querySelectorAll(".search-toggler").forEach((btn) => {
        btn.addEventListener("click", () => {
            setTimeout(tryFocus, 0);
        });
    });
}
focusSearchOnOpen();

$(function () {
    let $root = $(".wpcf7").first();
    let $form = $root.is("form") ? $root : $root.find("form").first();

    if (!$form.length) return;

    const $submitButton = $form.find(".wpcf7-submit");

    function checkForm() {
        let allFilled = true;
        let $required = $form.find(
            ".wpcf7-validates-as-required, .check_input"
        );

        let seenRadio = {};
        let seenCheckbox = {};

        $required.each(function () {
            if (!allFilled) return;

            let $field = $(this);
            let type = ($field.attr("type") || "").toLowerCase();
            let tag = this.tagName.toLowerCase();

            if (type === "radio") {
                let rname = $field.attr("name");
                if (!seenRadio[rname]) {
                    seenRadio[rname] = true;
                    if (
                        $form.find(
                            'input[type="radio"][name="' + rname + '"]:checked'
                        ).length === 0
                    ) {
                        allFilled = false;
                    }
                }
            } else if (type === "checkbox") {
                let cname = $field.attr("name");
                if (!seenCheckbox[cname]) {
                    seenCheckbox[cname] = true;
                    if (
                        $form.find(
                            'input[type="checkbox"][name="' +
                                cname +
                                '"]:checked'
                        ).length === 0
                    ) {
                        allFilled = false;
                    }
                }
            } else if (
                type === "text" ||
                type === "email" ||
                tag === "textarea"
            ) {
                if (($field.val() || "").trim() === "") {
                    allFilled = false;
                }
            } else if (tag === "select") {
                if (!$field.val()) {
                    allFilled = false;
                }
            }
        });

        $submitButton.prop("disabled", !allFilled);
    }

    $form.on(
        "input change",
        ".wpcf7-validates-as-required, .check_input",
        checkForm
    );

    checkForm();
});
$(function () {
  $(document).on("click", ".testimonial-toggle", function () {
    const $btn = $(this);
    const $text = $btn.siblings(".testimonial-five__text");
    const full = $text.data("full-text");
    const short = $text.data("short-text");
    const $label = $btn.find(".toggle-label");

    if ($btn.hasClass("expanded")) {
      $text.stop().animate({ opacity: 0 }, 200, function () {
        $text.text(short).animate({ opacity: 1 }, 200);
      });
      $btn.removeClass("expanded");
      $label.text("Zobraziť viac");
    } else {
      $text.stop().animate({ opacity: 0 }, 200, function () {
        $text.text(full).animate({ opacity: 1 }, 200);
      });
      $btn.addClass("expanded");
      $label.text("Zobraziť menej");
    }
  });
});
